import { COOKIE_PARAM_NAME } from '../consts/cookies.consts';
import { RouteFormatter } from '../routes';
import CookieService from '../services/cookie.service';

export const logOut = (e) => {
    e.preventDefault();

    CookieService.erase('filters');
    CookieService.erase('user');
    CookieService.erase('subscribe');
    CookieService.erase('__profilin');
    CookieService.erase(COOKIE_PARAM_NAME.SEARCH_FILTERS);
    CookieService.erase(COOKIE_PARAM_NAME.SEARCH_FILTERS_AVAILABILITY);
    CookieService.erase(COOKIE_PARAM_NAME.SEARCH_FILTERS_LOCATION);
    CookieService.erase(COOKIE_PARAM_NAME.REDIRECT);
    CookieService.erase(COOKIE_PARAM_NAME.REDIRECT_ONBOARD);

    fetch(RouteFormatter.signOut(), {
        headers: {
            Accept: 'text/html',
            'Content-Type': 'text/html',
        },
        credentials: 'include',
    }).then(() => window.location.replace('/'));
};
